import { WebLayout } from 'components/Layout';
import React from 'react';
import { Head } from 'components/Head';
import { Banner } from '../components/Banner';
import { WhyChooseWire24 } from '../components/WhyChooseWire24';
import { HowItWorks } from '../components/HowItWorks';
import { TrustedByThousands } from '../components/TrustedByThousands';
import { SecurityFAQs } from '../components/SecurityFAQs';
import { Motion, spring } from 'react-motion';

export const Landing = () => {
  const motionProps = {
    defaultStyle: { opacity: 0, translateY: 20 },
    style: {
      opacity: spring(1, { stiffness: 60, damping: 15 }),
      translateY: spring(0, { stiffness: 60, damping: 15 }),
    },
  };

  return (
    <WebLayout>
      <Head title="Wire24" description="The Future of Money Management" />
      <div className="md:mx-24 space-y-12">
        <Motion {...motionProps}>
          {(style) => (
            <div style={{ opacity: style.opacity, transform: `translateY(${style.translateY}px)` }}>
              <Banner />
            </div>
          )}
        </Motion>
        <Motion {...motionProps}>
          {(style) => (
            <div style={{ opacity: style.opacity, transform: `translateY(${style.translateY}px)` }}>
              <WhyChooseWire24 />
            </div>
          )}
        </Motion>
        <Motion {...motionProps}>
          {(style) => (
            <div style={{ opacity: style.opacity, transform: `translateY(${style.translateY}px)` }}>
              <HowItWorks />
            </div>
          )}
        </Motion>
        <Motion {...motionProps}>
          {(style) => (
            <div style={{ opacity: style.opacity, transform: `translateY(${style.translateY}px)` }}>
              <TrustedByThousands />
            </div>
          )}
        </Motion>
        <Motion {...motionProps}>
          {(style) => (
            <div style={{ opacity: style.opacity, transform: `translateY(${style.translateY}px)` }}>
              <SecurityFAQs />
            </div>
          )}
        </Motion>
      </div>
    </WebLayout>
  );
};
